/**
 * Returns array sorted by id ascending
 *
 * @param tuple
 */

export const sortById = (a: $TSFixMe, b: $TSFixMe) => {
  if (a.id > b.id) {
    return 1;
  }
  if (b.id > a.id) {
    return -1;
  }
};

export const sortByIdDesc = (a: $TSFixMe, b: $TSFixMe) => {
  if (a.id > b.id) {
    return -1;
  }
  if (b.id > a.id) {
    return 1;
  }
};

export const sortByRating = (a: $TSFixMe, b: $TSFixMe) => {
  if (b.rating > a.rating) {
    return 1;
  }
  if (a.rating > b.rating) {
    return -1;
  }
};

export const sortByDate = (a: $TSFixMe, b: $TSFixMe) => {
  const date1 = new Date(a.createdDate);
  const date2 = new Date(b.createdDate);
  if (date1 > date2) {
    return 1;
  }
  if (date2 > date1) {
    return -1;
  }
};
